import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=73e6da08&"
import script from "./OrderTable.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./OrderTable.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./OrderTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports